const BlockEvent = function( battleState, actor ) {
	this.eventHandle = 'block';
	this.actorId = actor.uid;
	
	this.execute = () => {
		battleState.onBattleEvent( this );	
	};
};
module.exports = BlockEvent
